module.exports = __webpack_public_path__ + "static/media/icon-google-play.781d6f7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-google-play.png
// module id = 404
// module chunks = 0